export enum ConversationFilter {
  UNREAD = 'unread',
  ACTIVE = 'active',
  UNSCHEDULED = 'unscheduled',
  LYRA_AI_ENABLED = 'lyraAiEnabled',
}

export enum ConversationTag {
  INACTIVE = 'inactive',
  UNSCHEDULED = 'unscheduled',
  AI_COACH_ENABLED = 'aiCoachEnabled',
  AT_RISK = 'atRisk',
  SELF_HARM = 'selfHarm',
}

export type Conversation = {
  clientId: string
  clientName: string
  lastMessageTime: Date | null
  hasUnreadMessage: boolean
  threadCount?: number
  tags?: ConversationTag[]
}
